/* INOMEGA mega menu desktop v3 (17/10/2026) : maquette v18. « Produits » ouvre le panneau, catégories à gauche. */
(function () {
  var mm = document.getElementById('inmg-mega');
  if (!mm || window.__inmgMega) return; window.__inmgMega = 1;
  var header = document.querySelector('header.main_header') || mm.parentNode;
  if (mm.parentNode !== header) header.appendChild(mm);
  if (getComputedStyle(header).position === 'static') header.style.position = 'relative';
  var desk = window.matchMedia('(min-width:1025px)');
  var openT, closeT, activeLink = null, warmed = false;
  var links = [].slice.call(document.querySelectorAll('#AccessibleNav > li > a.main_mega_heading'));
  var cats = [].slice.call(mm.querySelectorAll('.mg-cat'));
  /* précharge les visuels dès que la souris approche du header : pas d'image vide au premier survol */
  function warm() {
    if (warmed || !desk.matches) return; warmed = true;
    [].forEach.call(mm.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
  }
  header.addEventListener('pointerenter', warm);
  function show(cat) {
    if (!mm.querySelector('.mg-pane[data-cat="' + cat + '"]')) cat = 'cam';
    cats.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-cat') === cat ? 'true' : 'false'); });
    [].forEach.call(mm.querySelectorAll('.mg-pane'), function (p) { p.hidden = p.getAttribute('data-cat') !== cat; });
  }
  function open(cat, link) {
    clearTimeout(closeT);
    warm();
    show(cat);
    if (activeLink && activeLink !== link) { activeLink.classList.remove('inmg-mm-on'); activeLink.setAttribute('aria-expanded', 'false'); }
    activeLink = link || null;
    if (activeLink) { activeLink.classList.add('inmg-mm-on'); activeLink.setAttribute('aria-expanded', 'true'); }
    if (mm.hidden) { mm.hidden = false; void mm.offsetWidth; }
    mm.classList.add('open');
  }
  function close() {
    clearTimeout(openT);
    mm.classList.remove('open');
    if (activeLink) { activeLink.classList.remove('inmg-mm-on'); activeLink.setAttribute('aria-expanded', 'false'); activeLink = null; }
    closeT = setTimeout(function () { if (!mm.classList.contains('open')) mm.hidden = true; }, 180);
  }
  function soonClose() { clearTimeout(openT); clearTimeout(closeT); closeT = setTimeout(close, 220); }
  links.forEach(function (a) {
    var cat = a.getAttribute('data-mm');
    if (cat) a.setAttribute('aria-expanded', 'false');
    a.addEventListener('mouseenter', function () {
      if (!desk.matches) return;
      clearTimeout(closeT); clearTimeout(openT);
      if (!cat) { close(); return; }
      openT = setTimeout(function () { open(cat, a); }, mm.classList.contains('open') ? 0 : 120);
    });
    a.addEventListener('mouseleave', function () { if (desk.matches) soonClose(); });
    if (cat) a.addEventListener('focus', function () { if (desk.matches) open(cat, a); });
    /* 17/10 (Julien) : un clic sur « Produits » / « Kits » ouvre le panneau au lieu de quitter la page */
    if (cat) a.addEventListener('click', function (e) {
      if (!desk.matches) return;
      e.preventDefault();
      clearTimeout(openT);
      if (!(mm.classList.contains('open') && activeLink === a)) open(cat, a);
    });
  });
  /* même chose pour « Assistance » : le clic garde la carte ouverte (focus) au lieu d'ouvrir le centre d'aide */
  var help = document.querySelector('#AccessibleNav > li.inmg-help > a');
  if (help) help.addEventListener('click', function (e) {
    if (!desk.matches) return;
    e.preventDefault();
    if (mm.classList.contains('open')) close();
    help.focus();
  });
  mm.addEventListener('mouseenter', function () { clearTimeout(closeT); });
  mm.addEventListener('mouseleave', soonClose);
  /* catégories à gauche : survol, clic ou focus = produits du centre */
  cats.forEach(function (b) {
    var c = b.getAttribute('data-cat'), t;
    b.addEventListener('mouseenter', function () { clearTimeout(t); t = setTimeout(function () { show(c); }, 40); });
    b.addEventListener('mouseleave', function () { clearTimeout(t); });
    b.addEventListener('focus', function () { show(c); });
    b.addEventListener('click', function () { show(c); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mm.classList.contains('open')) { var l = activeLink; close(); if (l) l.focus(); } });
  document.addEventListener('focusin', function (e) { if (mm.classList.contains('open') && !mm.contains(e.target) && links.indexOf(e.target) < 0) close(); });
  document.addEventListener('inmg:cart:open', close);
  desk.addEventListener && desk.addEventListener('change', function () { if (!desk.matches) close(); });
})();
